export default __webpack_public_path__ + "static/media/pencil.ab3678cc.svg";